import { useState, useEffect } from "react";
import { Container } from "./style";
import { formatHourMinutesPmAm } from "helpers";

export const SunMoonCity = ({ sun, moon, pathIcon }) => {

  const [sunRise, setsunRise] = useState();
  const [sunSet, setsunSet] = useState();
  const [moonRise, setmoonRise] = useState();
  const [moonSet, setmoonSet] = useState();

  useEffect(() => {
    setsunRise(formatHourMinutesPmAm(sun.rise));
    setsunSet(formatHourMinutesPmAm(sun.set));
    setmoonRise(formatHourMinutesPmAm(moon.rise));
    setmoonSet(formatHourMinutesPmAm(moon.set));
  }, []);

  return (
    <Container className="SunMoon">
      <div className="sun-moon">
        <div className="sun-container">
          <div className="title">
            <img width="30" height="30" src={pathIcon(1)} alt="Sol" />
            <p className="subtitle">Sol</p>
          </div>
          <div className="sun-information">
            <p>
              Salida del sol: {sunRise}
            </p>
            <p>
              Puesta del sol: {sunSet}
            </p>
            <p>Duración: {sun.duration} hr</p>
          </div>
        </div>
        <div className="moon-container">
          <div className="title">
            <img width="30" height="30" src={pathIcon(33)} alt="Luna" />
            <p className="subtitle">Luna</p>
          </div>
          <div className="moon-information">
            <p>
              Salida de la luna:{" "}
              {moonRise}
            </p>
            <p>
              Puesta de la luna: {moonSet}
            </p>
            <p>Duración: {moon.duration} hr</p>
          </div>
        </div>
      </div>
    </Container>
  );
};
